import React from 'react';
import { Helmet } from "react-helmet";
import Hero from '../components/Hero';
import FeaturedProjects from '../components/FeaturedProjects';
import Expertise from '../components/Expertise';
import Clients from '../components/Clients';
import Excellence from '../components/Excellence';

const Home = () => {
  return (
    <>
      <Helmet>
        <title>Milstone Associates | Home</title>
        <meta name="description" content="Milstone Associates - Top-notch MEP Design, Engineering, and Supervision Services in Pakistan." />
        <meta property="og:title" content="Milstone Associates | Home" />
        <meta property="og:description" content="Milstone Associates - Top-notch MEP Design, Engineering, and Supervision Services in Pakistan." />
        <meta property="og:image" content="/images/logo.webp" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Milstone Associates | Home" />
        <meta name="twitter:description" content="Milstone Associates - Top-notch MEP Design, Engineering, and Supervision Services in Pakistan." />
        <meta name="twitter:image" content="/images/logo.webp" />
        <meta name="twitter:site" content="@milstoneassociate" />
        <script type="application/ld+json">{`
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "Milstone Associates",
            "url": "https://milestoneassociate.com/",
            "logo": "https://milestoneassociate.com/images/logo.webp",
            "contactPoint": [{
              "@type": "ContactPoint",
              "telephone": "+92 320 1111444",
              "contactType": "customer service",
              "areaServed": "PK",
              "availableLanguage": ["English", "Urdu"]
            }],
            "sameAs": [
              "https://www.linkedin.com/company/milstone-associates/"
            ]
          }
        `}</script>
        <script type="application/ld+json">{`
          {
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            "name": "Milstone Associates",
            "description": "Top-notch MEP Design, Engineering, and Supervision Services in Pakistan",
            "url": "https://milestoneassociate.com/",
            "telephone": "+92 320 1111444",
            "email": "info@milestoneassociate.com",
            "address": {
              "@type": "PostalAddress",
              "addressCountry": "PK",
              "addressRegion": "Islamabad"
            },
            "geo": {
              "@type": "GeoCoordinates",
              "latitude": "33.6844",
              "longitude": "73.0479"
            },
            "openingHours": "Mo-Fr 09:00-18:00",
            "priceRange": "$$",
            "serviceArea": {
              "@type": "Country",
              "name": "Pakistan"
            },
            "hasOfferCatalog": {
              "@type": "OfferCatalog",
              "name": "MEP Services",
              "itemListElement": [
                {
                  "@type": "Offer",
                  "itemOffered": {
                    "@type": "Service",
                    "name": "Electrical Services"
                  }
                },
                {
                  "@type": "Offer",
                  "itemOffered": {
                    "@type": "Service",
                    "name": "Mechanical Services"
                  }
                },
                {
                  "@type": "Offer",
                  "itemOffered": {
                    "@type": "Service",
                    "name": "Plumbing Services"
                  }
                }
              ]
            }
          }
        `}</script>
        <link rel="sitemap" type="application/xml" title="Sitemap" href="https://milestoneassociate.com/sitemap.xml" />
      </Helmet>
      <div className="min-h-screen">
        <Hero />
        <Excellence />
        <FeaturedProjects />
        <Expertise />
        <Clients />
      </div>
    </>
  );
};

export default Home;
